export const home = {
	name: 'home',
	title: 'Home',
	content:
		'<path d="M 3.753,13.944v8.25h6v-6c0-0.828,0.672-1.5,1.5-1.5h1.5c0.828,0,1.5,0.672,1.5,1.5v6h6v-8.25 " stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 0.753,12.444 L10.942,2.255c0.586-0.586,1.535-0.586,2.121-0.001c0,0,0,0,0.001,0.001l10.189,10.189" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>',
};
